import { useQuery } from "@tanstack/react-query"
import { getAllMyJobs } from "../actions/getAllMyJobs"

interface Props {
    page: number,
    pageSize: number,
    clientUid?: string | null;
    context?: string;
    search?: string;
    searchBy?: "id" | "name";
}

export const useJobsAllQuery = ({ page, pageSize, clientUid = null, context, search = "", searchBy = "name" }: Props) => {
    
    const jobsAllQuery = useQuery({
        queryKey: context ? ["jobs", clientUid, context, page, pageSize, search, searchBy] : ["jobs", clientUid, page, pageSize, search, searchBy],
        queryFn: () => getAllMyJobs({ page, pageSize, clientUid, search, searchBy }),
        retry: 0,
        staleTime: 0,
    })

    return jobsAllQuery
}
